import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';
import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {BasicValidators} from "../shared/basic-validators";
import {FaturasService} from "./faturas.service";
import {FaturasModel} from "./faturas.model";
import {UnidadesService} from "../unidades/unidades.service";
import {TiposClientesService} from "../clientes/tipos-clientes.service";
import {BancosService} from "../bancos/bancos.service";
import {MoedasService} from "../moedas/moedas.service";
import {LoginService} from "../login/login.service";


@Component({
  selector: 'app-faturas-form',
  templateUrl: './faturas-form.component.html'
})
export class FaturasFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  fatura: FaturasModel = new FaturasModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  isoMoeda = 'BRL';

  listClientes = [];
  listUnidades = [];
  listBancos = [];
  listMoedas = [];
  listFormaPagamento = [{
    "valor": "deposito",
    "texto": "Depósito"
  }/*,{
    "valor": "boleto",
    "texto": "Boleto"
  }*/];

  listItensFatura = [{
    "id_item": null,
    "id_fatura": null,
    "descricao": "",
    "valor": 0.00,
    "valor_unitario": 0.00,
    "quantidade": 1
  }];

  listItensNaoEditaveis = [];

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private faturasService: FaturasService,
    private tiposClientesService: TiposClientesService,
    private unidadesService: UnidadesService,
    private bancosService: BancosService,
    private moedasService: MoedasService,
    private _location: Location,
    public loginService: LoginService,
    public func: Funcoes,
    public global: Global
  ) {

    this.form = formBuilder.group({
      id_fatura: [],
      id_cliente: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      id_unidade: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      forma_pagamento: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      valor_total: [],
      id_banco: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      id_moeda: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      data_vencimento: ['', [
        Validators.required
      ]],
      nota_fiscal: []
    });

    // busca unidades
    this.unidadesService.get()
      .subscribe( json => {
        this.listUnidades = json.Payload;
      });

    // busca bancos
    this.bancosService.get()
      .subscribe( json => {
        this.listBancos = json.Payload;
      });

    this.moedasService.get()
      .subscribe(
        json => {
          this.listMoedas = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    // busca clientes por tipo
    this.tiposClientesService.get( ["clientes"] )
      .subscribe(
        json => {
          //this.ficha = json.Payload;


          for(let x in json.Payload){
            switch (json.Payload[x].id_tipo){
              case "1":
                this.listClientes = this.func.mergeObjByProp(this.listClientes, json.Payload[x].clientes, 'id_cliente');
                break;

              case "2":
                this.listClientes = this.func.mergeObjByProp(this.listClientes, json.Payload[x].clientes, 'id_cliente');
                break;

              case "6":
                this.listClientes = this.func.mergeObjByProp(this.listClientes, json.Payload[x].clientes, 'id_cliente');
                break;
              default:
                break;
            }
          }

        },
        error => {
          this.func.showErro(error.json());
        });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    let id = this.route.params.subscribe(params => {
      let id = params['id_fatura'];

      if(this.pageIsUpd){
        this.title = this.func.traduzir('front.editarFatura');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarFatura') : this.func.traduzir('front.cadastrarNovaFatura');
      }

      if (!id) {
        return;
      }

      this.faturasService.getById(id, ['itens', 'fichas', 'laudos', 'laudos_cd', 'laudos_tecnicos'])
        .subscribe(
          json => {
            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }

            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarFatura')+': '+json.Payload[0].id_fatura;
            }else{
              this.title = this.func.traduzir('front.visualizarFatura')+': '+json.Payload[0].id_fatura;
            }
            this.fatura = json.Payload[0];
            if (this.fatura.valor_fixo && this.pageIsUpd) {
              this.func.alerta(this.func.traduzir('front.erro'), this.func.traduzir('front.faturaValorFixoNaoEditavel'), 'erro');
              this.router.navigate(['/painel/faturas']);
              return;
            }
            this.listItensFatura = (json.Payload[0].itens || []).map(item => {
              let qty = Number(item.quantidade);
              if (isNaN(qty) || qty <= 0) {
                qty = 1;
              }
              item.quantidade = qty;
              item.valor_unitario = Number(item.valor) / qty;
              return item;
            });

            this.listItensNaoEditaveis = [];

            // 1. Fichas
            if (json.Payload[0].fichas) {
              let container = 'a';
              for (let ficha of json.Payload[0].fichas) {
                let c = (!ficha.container || ficha.container == '') ? ficha.id_ficha : ficha.container;
                let valor = (container != c) ? json.Payload[0].valor_preliminares : 0.00;
                container = ficha.container;

                this.listItensNaoEditaveis.push({
                  descricao: 'Preliminar - ' + (ficha.mercadoria ? ficha.mercadoria.nome_pt : '') + ' - ' + (ficha.container || '') + ' - (' + this.func.formatDate('data', ficha.data_inspecao, this.loginService.getUserInfo(true)) + ')',
                  quantidade: 1,
                  valor_unitario: valor,
                  valor: valor
                });
              }
            }

            // 2. Laudos PDF
            if (json.Payload[0].laudos) {
              for (let laudo of json.Payload[0].laudos) {
                this.listItensNaoEditaveis.push({
                  descricao: 'Laudo Técnico - ' + laudo.numero + ' - ' + (laudo.mercadoria ? laudo.mercadoria.nome_pt : '') + ' - ' + (laudo.container || '') + ' - (' + this.func.formatDate('data', laudo.data, this.loginService.getUserInfo(true)) + ')',
                  quantidade: 1,
                  valor_unitario: laudo.valor,
                  valor: laudo.valor
                });
              }
            }

            // 3. Laudos CD
            if (json.Payload[0].laudos_cd) {
              for (let laudo of json.Payload[0].laudos_cd) {
                this.listItensNaoEditaveis.push({
                  descricao: 'Laudo CD - ' + (laudo.referencia || laudo.id_laudo_cd) + ' - ' + (laudo.produto ? laudo.produto.nome_pt : '') + ' - ' + (laudo.identificacao_transporte || '') + ' - (' + this.func.formatDate('data', laudo.data_descarga, this.loginService.getUserInfo(true)) + ')',
                  quantidade: 1,
                  valor_unitario: laudo.valor,
                  valor: laudo.valor
                });
              }
            }

            // 4. Laudos Técnicos
            if (json.Payload[0].laudos_tecnicos) {
              for (let laudo of json.Payload[0].laudos_tecnicos) {
                this.listItensNaoEditaveis.push({
                  descricao: 'Laudo Técnico - ' + (laudo.referencia || laudo.id_laudo_tecnico) + ' - ' + (laudo.produto ? laudo.produto.nome_pt : '') + ' - ' + (laudo.identificacao_transporte || '') + ' - (' + this.func.formatDate('data', laudo.data_descarga, this.loginService.getUserInfo(true)) + ')',
                  quantidade: 1,
                  valor_unitario: laudo.valor,
                  valor: laudo.valor
                });
              }
            }

            this.somaValorTotal();
            this.alteraMoeda(this.fatura.id_moeda);
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {

    this.enviando = true;
    let result,
      values = this.fatura; //this.form.value;

    values['itens'] = this.listItensFatura;

    if (values.id_fatura) {
      result = this.faturasService.editar(values, values.id_fatura);
    } else {
      result = this.faturasService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'faturas']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });

  }

  somaValorTotal(){
    let valor = 0;

    for (let item of this.listItensNaoEditaveis) {
      valor += Number(item.valor);
    }

    for(let i in this.listItensFatura){
      let qty = Number(this.listItensFatura[i]['quantidade']);
      if(isNaN(qty) || qty === 0){
        qty = 1;
      }
      this.listItensFatura[i]['valor'] = (this.listItensFatura[i]['valor_unitario'] * qty);
      valor = valor + (this.listItensFatura[i]['valor_unitario'] * qty);
    }
    this.fatura.valor_total = valor;
  }

  validaQuantidade(item) {
    let qty = Number(item.quantidade);
    if (isNaN(qty) || qty <= 0) {
      item.quantidade = null;
      setTimeout(() => {
        item.quantidade = 1;
        this.somaValorTotal();
      }, 0);
    } else {
      this.somaValorTotal();
    }
  }

  addItemFatura(){
    this.listItensFatura.push({
      "id_item": null,
      "id_fatura": null,
      "descricao": "",
      "valor": 0.00,
      "valor_unitario": 0.00,
      "quantidade": 1
    });
  }

  removeItemFatura(i){
    this.listItensFatura.splice(i, 1);
    this.somaValorTotal();
  }

  alteraMoeda(e){
    console.log(e);

    for(let i in this.listMoedas){
      console.log(this.listMoedas[i]['id']+' == '+e);
      if(this.listMoedas[i]['id'] == e){
        this.isoMoeda = this.listMoedas[i]['iso'];
        console.log(this.listMoedas[i]['iso']);
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/faturas/faturas-form.component.ts